/**
 * The one password policy, for every form that sets a password (signup, reset,
 * profile change, workspace invite). The backend enforces the same list in
 * services/auth/business-logic/password-rules.js; keep the two in step.
 */
export const PASSWORD_REQUIREMENTS = [
  { test: value => value.length >= 8, message: 'Password must be at least 8 characters' },
  { test: value => value.length <= 128, message: 'Password must be at most 128 characters' },
  { test: value => /[a-z]/.test(value), message: 'Password must contain at least one lowercase letter' },
  { test: value => /[A-Z]/.test(value), message: 'Password must contain at least one uppercase letter' },
  { test: value => /\d/.test(value), message: 'Password must contain at least one number' },
  {
    test: value => /[^A-Za-z0-9\s]/.test(value),
    message: 'Password must contain at least one special character (e.g. @ # $ ! %)',
  },
  { test: value => !/\s/.test(value), message: 'Password cannot contain spaces' },
];

export const PASSWORD_HINT = 'Use 8+ characters with an uppercase letter, a lowercase letter, a number and a symbol.';

/** The first requirement the password misses, or '' when it meets them all. */
export const passwordProblem = value => {
  const text = String(value ?? '');
  const failed = PASSWORD_REQUIREMENTS.find(rule => !rule.test(text));
  return failed ? failed.message : '';
};

/** The same list as <Form.Item> rules; the form shows the first one missed. */
export const passwordRules = PASSWORD_REQUIREMENTS.map(rule => ({
  transform: value => !rule.test(String(value ?? '')),
  message: rule.message,
}));
